import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from './toast.service';

let errorShown = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);

  // 🔹 For URLs that do not rely on `type`
  const urlNameMap: { [key: string]: string } = {
    'SitesList': 'Site List',
    'CBList': 'CB List',
    'DataloggerList': 'DL List',
    'DLList': 'Detailed DL List',
    'SensorList': 'Sensor List',
    'WOQtyList': 'WO Quantity List',
    'DashboardData': 'Dashboard Data',
    'SideMenu': 'Sidebar Menu',
    'ConsumerSearch': 'Consumer Search',
    'LogData': 'Log Data',
    'LogFoldersList': 'Log Folders',
    'LogFilesList': 'Log Files',
    'GetConsumptionWORecharge':'Consumption Without Recharge'
  };

  // 🔸 Only for URLs where `type` determines the name
  const typeBasedUrls = ['RechargeSummary', 'DashboardInnerBoxData', 'Reports'];

  const typeNameMap: { [key: string]: string } = {
    // Recharge Summary types
    'DAILY_RECHARGE': 'Daily Recharge ',
    'GW_PERFORMANCE': 'Gateway Performance',
    'MONTHLY_RECHARGE': 'Monthly Recharge ',
    'SETTLEMENT_RECHARGE': 'Settlement Recharge',
    'BILLING_COLLECTION': 'Billing Collection',
    'DLNOTCONNECT': 'DL Not Connected',
    'DLALL': 'All DLs',
    'DGNOTCONNECT': 'DG Not Connected',
    'DGALL': 'All DGs',
    'SENSORCUTOFF': 'Sensor Cutoff',
    'SENSORCUTOFF-L': 'Sensor Cutoff',
    'SENSORZEROREADING': 'Zero Reading Sensors',
    'DGON': 'DG ON',
    'GRIDON': 'Grid ON',
    'LOW-BALANCE': 'Low Balance',
    'OVERLOAD-GRID': 'Overload Grid',
    'OVERLOAD-DG': 'Overload DG',
    'TOWER-WISE-CONSUMPTION': 'Towerwise Consumption',
    'RADIUS-SERVICE-PROVIDED': 'Radius Service Provided',
    'OVERALL-LOAD': 'Overall Load',
    'CONSUMPTION':'Consumption',
    'BILLING':'Billing',
    // Reports types
    'ALARMS_REPORT': 'Alarms Report',
    'ASSETS_MASTER': 'Assets Master',
    'DAILY_REPORT': 'Daily Report',
    'BILLING_REPORT': 'Billing Report',
    'DR_CR_REPORT': 'DR CR Report',
    'LOAD_TYPE_MASTER':'Load Type Master',
    'MONTHLY_REPORT':'Monthly Report',
    'READING_CALIBRATION':'Reading Calibration',
    'RECHARGE_HISTORY':'Recharge History'
  };


  return next(req).pipe(
    catchError((error) => {
      const url = req.url;
      const params = req.params;

      if ( error && !errorShown) {
        let friendlyName = 'API';

        // 1️⃣ First, check if the URL is one of the "type"-based ones
        const typeBasedMatch = typeBasedUrls.find(api => url.includes(api));
        if (typeBasedMatch) {
          const type = params.get('type');
          if (type && typeNameMap[type]) {
            friendlyName = typeNameMap[type];
          } else {
            friendlyName = `${typeBasedMatch} (Unknown Type)`;
          }
        } else {
          // 2️⃣ Otherwise, match from static URL map
          const matchingUrlKey = Object.keys(urlNameMap).find(key => url.includes(key));
          if (matchingUrlKey) {
            friendlyName = urlNameMap[matchingUrlKey];
          }
        }

        // 3️⃣ Finally, show toast
        toastService.showToast(
          `${friendlyName} : ${error.error?.Message || 'Something Went Wrong'}`,
          'colored',
          5000,
          'danger'
        );

        if (error.error?.Message === 'Provide Valid Token') {
          errorShown = true;
        }
      }

      return throwError(() => error);
    })
  );
};
